export default {
  ADS: /\/admin\/m_campaigns\/(.*)\//,
  ADS_LIST: /\/admin\/m_campaigns(?:\/)?$/,
  ADS_TARGETS: /\/admin\/m_campaigns\/(.*?)\/objectives\/[tT]argets?$/,
  ADS_QUOTAS: /\/admin\/m_campaigns\/(.*?)\/objectives\/[qQ]uotas/,
  JOBS: /\/admin\/jobs\/(.*)\//,
  JOBS_LIST: /\/admin\/jobs(?:\/)?$/,
  SURVEY: /\/surveys\/(.*)\//,
  SURVEY_REPORT_V2: /\/surveys\/(.*)\/reports\/(?!new)[^/]+\//,
  PRICER_PROJECT: /\/admin\/pricer\/projects\/(.*)\//,
  PRICER_LIST: /\/admin\/pricer\/projects(?:\/)?$/,
  MAILING_LISTS: /\/mailing\/lists(?:\/)?$/,
  EMAIL_CAMPAIGNS: /\/mailing\/campaigns(?:\/)?$/,
  TEMPLATES: /\/mailing\/templates(?:\/)?$/,
  TEMPLATE: /\/mailing\/templates\/(.*)\//,
  LM_SURVEY: /\/lm_surveys\/(.*)\//,
  MASTER_REPORT: /\/master-reports\/(.*)\//,
};
